module.exports = __webpack_public_path__ + "img/logo--white.c245dd2.png";